import { liteClient } from '../algoliaJS/algoliasearch-lite-5.20.3.umd.min.js';
import { getCookie } from '../utils/cookieUtils.js';
import instantsearch from '../algoliaJS/instantsearch-4.77.3.min.js';
const searchClient = liteClient('5PA7LYGKHW', '15792078a1b213be8f8d538db0f80825');

const hasLsgVisitorCookie = getCookie('lsgvisitor') !== null;

const search = instantsearch({
    searchClient: searchClient,
    indexName: 'PROD_Shearings_Rebrand',
    insights: !hasLsgVisitorCookie, // Disable for LSG visitors
    searchFunction: function (helper) {
        var searchResults = $('.ftResults__results');
        if (helper.state.query === '') {
            searchResults.hide();
            return;
        }
        helper.search();
        searchResults.show();
    }
});

const searchbox =
    instantsearch.widgets.searchBox({
        container: '[data-freetype-search-button]',
        autofocus: true,
        searchAsYouType: true,
        showReset: false,
        showSubmit: false,
        showLoadingIndicator: false,
        placeholder: 'Where will you go next?',
        cssClasses: { input: 'l-form__input' }
    });

var customClearAllWidget = {
    init: function (args) {
        var helper = args.helper;
        const clearFreetype = document.querySelector('[data-freetype-search-clear-button]');

        if (!clearFreetype) return;

        clearFreetype.addEventListener('click', function () {
            helper.state.query = '';
            $('[data-freetype-search-results]').hide();
            $('.ais-SearchBox-input').val('');
        });
    },
};
search.addWidget(customClearAllWidget);

const hits = instantsearch.widgets.hits({
    container: '[data-freetype-hits-container]',
    hitsPerPage: 4,
    cssClasses: {
        list: 'ftResults__cards'
    },
    templates: {
        item: function (data) {

            // Get highlighted name using _highlightResult
            let highlightedName = '';
            if (data._highlightResult && data._highlightResult.PageName && data._highlightResult.PageName.value) {
                // This will include <em> tags around highlighted parts
                highlightedName = data._highlightResult.PageName.value;
            } else {
                highlightedName = data.PageName;
            }




            var imageDiv = data.ImgPreview
                ? `<div class="c-card__img-blk"><img lazy class="c-card__image" src="${data.ImgPreview}?w=200&h=200&auto=compress,enhance,format&q=72&fit=crop&crop=focal" alt="${data.PageName}"></div>`
                : '';

            if (data.ContentType == "Tour") {
                return `
                <div class="c-card c-card--FTSR c-card--FTSR--tour">
                    <div class="c-card__grid">
                        <div class="c-card__item c-card__item--media">
                            ${imageDiv}
                        </div>
                        <div class="c-card__item c-card__item--content">
                            <div class="contentWrap">
                                <h4>${highlightedName}</h4>
                                <p>${data.TextUnderImg ?? ""}</p> 
                            </div>
                        </div>
                        <a href="${data.URL}" class="c-card__item c-card__item--linkCover"
                               data-insights-object-id="${data.objectID}"
                               data-insights-position="${data.__position}"
                               data-insights-query-id="${data.__queryID}"
                        ></a>
                    </div>
                </div>`
            }
            if (data.ContentType == "Destination") {
                return `
                <div class="c-card c-card--FTSR c-card--FTSR--destination">
                    <div class="c-card__grid">
                        <div class="c-card__item c-card__item--media">
                            ${imageDiv}
                        </div>
                        <div class="c-card__item c-card__item--content">
                            <div class="contentWrap">
                                <h4>${highlightedName}</h4>
                            </div>
                        </div>
                        <a href="${data.URL}" class="c-card__item c-card__item--linkCover"
                               data-insights-object-id="${data.objectID}"
                               data-insights-position="${data.__position}"
                               data-insights-query-id="${data.__queryID}"                       
                        ></a>
                    </div>
                </div>`
            }
            if (data.ContentType == "ContentPage") {
                return `
                <div class="c-card c-card--FTSR c-card--FTSR--destination">
                    <div class="c-card__grid">
                        <div class="c-card__item c-card__item--media">
                            ${imageDiv}
                        </div>
                        <div class="c-card__item c-card__item--content">
                            <div class="contentWrap">
                                <h4>${highlightedName}</h4>
                            </div>
                        </div>
                        <a href="${data.URL}" class="c-card__item c-card__item--linkCover"
                               data-insights-object-id="${data.objectID}"
                               data-insights-position="${data.__position}"
                               data-insights-query-id="${data.__queryID}"                        
                        ></a>
                    </div>
                </div>`
            }
        }
    }
});

const hpp = instantsearch.widgets.hitsPerPage({
    container: '[data-freetype-hits]',
    items: [
        { label: '4 hits per page', value: 4, default: true },
        { label: '8 hits per page', value: 8 },
    ],
});

const pagination = instantsearch.widgets.pagination({
    container: '[data-freetype-hits-pagination]',
    scrollTo: false,
    showFirst: false,
    showLast: false
});


search.addWidgets([searchbox, hits, hpp, pagination]);
search.start();



if (!hasLsgVisitorCookie) {
    document.addEventListener('DOMContentLoaded', () => {
        window.aa('init', {
            appId: '5PA7LYGKHW',
            apiKey: '15792078a1b213be8f8d538db0f80825',
        });
    });

    // Search Results Click Tracking
    document.addEventListener('click', function (e) {
        const target = e.target;

        // Check if the clicked element is a search result link
        if (target.matches('[data-insights-object-id]')) {

            // Get the data attributes
            const objectID = target.getAttribute('data-insights-object-id');
            const position = parseInt(target.getAttribute('data-insights-position'), 10);
            const queryID = target.getAttribute('data-insights-query-id');

            // Track the click with Algolia Insights
            window.aa('clickedObjectIDsAfterSearch', {
                eventName: 'Result Clicked',
                index: 'PROD_Shearings_Rebrand',
                objectIDs: [objectID],
                positions: [position],
                queryID: queryID,
            });
        }
    });
}


//Second free-text search:
if (document.querySelector('[data-freetype-hits-container2]') !== null) {
    const search2 = instantsearch({
        searchClient: searchClient,
        indexName: 'PROD_Shearings_Rebrand',
        insights: !hasLsgVisitorCookie, // Disable for LSG visitors
        searchFunction: function (helper) {
            var searchResults = $('.ftResults__results2');
            if (helper.state.query === '') {
                searchResults.hide();
                return;
            }
            helper.search();
            searchResults.show();
        }
    });

    const searchbox2 =
        instantsearch.widgets.searchBox({
            container: '[data-freetype-search-button2]',
            autofocus: false,
            searchAsYouType: true,
            showReset: false,
            showSubmit: false,
            showLoadingIndicator: false,
            placeholder: 'Where will you go next?',
            cssClasses: { input: 'l-form__input' }
        });

    const hits2 = instantsearch.widgets.hits({
        container: '[data-freetype-hits-container2]',
        hitsPerPage: 4,
        cssClasses: {
            list: 'ftResults__cards'
        },
        templates: {
            item: function (data) {
                // Get highlighted name using _highlightResult
                let highlightedName = '';
                if (data._highlightResult && data._highlightResult.PageName && data._highlightResult.PageName.value) {
                    // This will include <em> tags around highlighted parts
                    highlightedName = data._highlightResult.PageName.value;
                } else {
                    highlightedName = data.PageName;
                }


                //Tour Page
                if (data.ContentType == "Tour") {
                    return `
                <div class="c-card c-card--FTSR c-card--FTSR--tour">
                    <div class="c-card__grid">
                        <div class="c-card__item c-card__item--media">
                            <div class="c-card__img-blk">
                                <img lazy class="c-card__image" src="${data.ImgPreview}?w=200&h=200&auto=compress,enhance,format&q=72&fit=crop&crop=focal" alt="${data.PageName}">
                            </div>
                        </div>
                        <div class="c-card__item c-card__item--content">
                            <div class="contentWrap">
                                <h4>${highlightedName}</h4>
                                <p>${data.TextUnderImg}</p> 
                            </div>
                        </div>
                        <a href="${data.URL}" class="c-card__item c-card__item--linkCover"
                               data-insights-object-id="${data.objectID}"
                               data-insights-position="${data.__position}"
                               data-insights-query-id="${data.__queryID}"                                
                        ></a>
                    </div>
                </div>`
                }
                if (data.ContentType == "Destination") {
                    return `
                <div class="c-card c-card--FTSR c-card--FTSR--destination">
                    <div class="c-card__grid">
                        <div class="c-card__item c-card__item--media">
                            <div class="c-card__img-blk">
                                <img lazy class="c-card__image" src="${data.ImgPreview}?w=200&h=200&auto=compress,enhance,format&q=72&fit=crop&crop=focal" alt="${data.PageName}">
                            </div>
                        </div>
                        <div class="c-card__item c-card__item--content">
                            <div class="contentWrap">
                                <h4>${highlightedName}</h4>
                            </div>
                        </div>
                        <a href="${data.URL}" class="c-card__item c-card__item--linkCover"
                               data-insights-object-id="${data.objectID}"
                               data-insights-position="${data.__position}"
                               data-insights-query-id="${data.__queryID}"                               
                        ></a>
                    </div>
                </div>`
                }
                if (data.ContentType == "ContentPage") {
                    return `
                <div class="c-card c-card--FTSR c-card--FTSR--destination">
                    <div class="c-card__grid">
                        <div class="c-card__item c-card__item--media">
                            <div class="c-card__img-blk">
                                <img lazy class="c-card__image" src="${data.ImgPreview}?w=200&h=200&auto=compress,enhance,format&q=72&fit=crop&crop=focal" alt="${data.PageName}">
                            </div>
                        </div>
                        <div class="c-card__item c-card__item--content">
                            <div class="contentWrap">
                                <h4>${highlightedName}</h4>
                            </div>
                        </div>
                        <a href="${data.URL}" class="c-card__item c-card__item--linkCover"
                               data-insights-object-id="${data.objectID}"
                               data-insights-position="${data.__position}"
                               data-insights-query-id="${data.__queryID}"                                
                        ></a>
                    </div>
                </div>`
                }
            }
        }
    });

    const hpp2 = instantsearch.widgets.hitsPerPage({
        container: '[data-freetype-hits2]',
        items: [
            { label: '4 hits per page', value: 4, default: true },
            { label: '8 hits per page', value: 8 },
        ],
    });

    const pagination2 = instantsearch.widgets.pagination({
        container: '[data-freetype-hits-pagination2]',
        scrollTo: false,
        showFirst: false,
        showLast: false
    });

    search2.addWidgets([searchbox2, hits2, hpp2, pagination2]);
    search2.start();
}
